import React, { useRef, useState, useEffect } from 'react';

import Button from './Button';
import './ImageUpload.css';

const FileUpload = props => {
    const [file, setFile] = useState();
    const [previewUrl, setPreviewUrl] = useState();
    const [isValid, setIsValid] = useState(false);

    const filePickerRef = useRef();

    useEffect(() => {
        if (!file) {
            return;
        }

        // Added this to Only generate preview for images
        if (file.type.startsWith('image/')) {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                setPreviewUrl(fileReader.result);
            };
            fileReader.readAsDataURL(file);
        } else {
            setPreviewUrl(null);
        }
    }, [file]);

    const pickedHandler = event => {
        let pickedFile;
        /*let fileIsValid = isValid; Commenting this*/
        let fileIsValid = false; /* Added this */
        if (event.target.files && event.target.files.length === 1) {
            pickedFile = event.target.files[0];
            setFile(pickedFile);
            setIsValid(true);
            fileIsValid = true;
        } else {
            setIsValid(false);
            /*fileIsValid = false; Commenting this */
        }
        props.onInput(props.id, pickedFile, fileIsValid);
    };

    const pickImageHandler = () => {
        filePickerRef.current.click();
    };

    return (
        <div className="form-control">
            <input
                id={props.id}
                ref={filePickerRef}
                style={{ display: 'none' }}
                type="file"
                /*accept=".jpg,.png,.jpeg"*/
                accept={props.accept || '*/*'}
                onChange={pickedHandler}
            />

            <div className={`image-upload ${props.center && 'center'}`}>

                {/* IMAGE PREVIEW ONLY */}
                {file && file.type.startsWith('image/') && (
                    <div className="image-upload__preview">
                        <img src={previewUrl} alt="Preview" />
                    </div>
                )}

                {/* NON-IMAGE FILE (NO PREVIEW BOX) */}
                {file && !file.type.startsWith('image/') && (
                    <p className="file-preview-text">
                        📄 {file.name}
                    </p>
                )}

                {/* NO FILE SELECTED */}
                
                {!file && (
                    <div className="image-upload__preview">
                        <p>Please pick a file.</p>
                    </div>
                )} 

                <Button type="button" onClick={pickImageHandler}>
                    PICK FILE
                </Button>
            </div>

            {!isValid && <p>{props.errorText}</p>}
        </div>
    );
};

export default FileUpload;
